import { makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) => ({
  root: {
    flexGrow: 1,
    display: 'flex',
    '& .MuiTabs-scroller': {
      overflowY: 'auto !important',
    },
  },
  tabs: {
    borderRight: `1px solid ${theme.palette.divider}`,
    width: '350px',
    height: '500px',
    '& .MuiTabs-flexContainerVertical': {
      overflow: 'hidden',
    },
    '&:focus': {
      outline: '1px solid black',
    },
    minWidth: '170px',
  },
  indicator: {
    display: 'none',
  },
  tab: {
    textTransform: 'none',
  },
}));
